import { Component, computed, DestroyRef, inject, input, OnInit, Signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { OcrService } from '../service/ocr.service';
import { Dimension2d, pointRect, WordRect } from '../page-overlay/model';
import { TextSelectionOverlayComponent } from './text-selection-overlay/text-selection-overlay.component';
import { OverlayDimensionService } from '../page-overlay/overlay-dimension.service';
import { OcrSelectionService } from '../service/ocr-selection.service';
import { LassoSelectionDirective } from '../page-overlay/lasso-selection.directive';

@Component({
  imports: [TextSelectionOverlayComponent],
  selector: 'shared-dp-ocr-overlay',
  templateUrl: './ocr-overlay.component.html',
})
export class OcrOverlayComponent implements OnInit {
  readonly pageId = input.required<string>();

  protected readonly boxSelection = inject(LassoSelectionDirective);
  private readonly dimensionService = inject(OverlayDimensionService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly ocrService = inject(OcrService);
  private readonly ocrSelectionService = inject(OcrSelectionService);

  protected readonly selectedWordRects: Signal<WordRect[]> = computed(() => {
    const lasso =
      this.boxSelection.currentLasso() ?? pointRect(this.boxSelection.currentMousePosition());

    return this.ocrService.getWordsInRect(this.pageId(), lasso);
  });

  protected readonly dimension = computed<Dimension2d | undefined>(
    () => this.dimensionService.dimensionsByPageId()[this.pageId()],
  );

  ngOnInit(): void {
    this.boxSelection.lastReleasedLasso$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      if (!this.selectedWordRects().length) {
        return;
      }

      const selectedWords = this.selectedWordRects().map((rect) =>
        this.ocrService.getWord(this.pageId(), rect),
      );
      this.ocrSelectionService.newSelection(selectedWords, this.selectedWordRects(), this.pageId());
    });
  }
}
